<script setup lang="ts">
// Product of Launch Maniac LLC, Las Vegas, Nevada - (725) 444-8200 support@launchmaniac.com

import { RouterView } from 'vue-router';
</script>

<template>
  <RouterView />
</template>
